<template>
  <div class="systemServiceList">
    <el-button type="primary" class="addService" @click="addService"
      >新增服务</el-button
    >
    <el-table :data="systemServiceList">
      <el-table-column label="服务标题" prop="name"></el-table-column>
      <el-table-column label="服务副标题" prop="byName"></el-table-column>
      <el-table-column label="服务链接" prop="url"></el-table-column>
      <el-table-column label="背景图片" prop="icoUrl">
        <template slot-scope="scope">
          <img :src="scope.row.icoUrl" alt="" />
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import request from "@/utils/request";
export default {
  name: "systemServiceList",
  computed: {
    ...mapGetters(["request"]),
  },
  data() {
    return {
      systemServiceList: [
        // {
        //   name: "协同办公",
        //   byName: "这里是专题描述",
        //   icoUrl: require("@/assets/hunankeji/zonghechaxun.png"),
        //   url: "",
        //   id:""
        // },
        // {
        //   name: "综合查询",
        //   byName: "最好不要超过10个字符",
        //   icoUrl: require("@/assets/hunankeji/zonghechaxun.png"),
        //   url: "",
        // },
        // {
        //   name: "智能填报",
        //   byName: "线上审批 一站可达",
        //   icoUrl: require("@/assets/hunankeji/zonghechaxun.png"),
        //   url: "",
        // },
        // {
        //   name: "信息公开",
        //   byName: "线上审批 一站可达",
        //   icoUrl: require("@/assets/hunankeji/zonghechaxun.png"),
        //   url: "",
        // },
        // {
        //   name: "教育阳光服务",
        //   byName: "线上审批 一站可达",
        //   icoUrl: require("@/assets/hunankeji/zonghechaxun.png"),
        //   url: "",
        // },
        // {
        //   name: "主题教育",
        //   byName: "线上审批 一站可达",
        //   icoUrl: require("@/assets/hunankeji/zonghechaxun.png"),
        //   url: "",
        // },
        // {
        //   name: "审核评估",
        //   byName: "线上审批 一站可达",
        //   icoUrl: require("@/assets/hunankeji/zonghechaxun.png"),
        //   url: "",
        // },
        // {
        //   name: "创新创业",
        //   byName: "线上审批 一站可达",
        //   icoUrl: require("@/assets/hunankeji/zonghechaxun.png"),
        //   url: "",
        // },
        // {
        //   name: "学工服务",
        //   byName: "线上审批 一站可达",
        //   icoUrl: require("@/assets/hunankeji/zonghechaxun.png"),
        //   url: "",
        // },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    addService() {
      this.$router.push({ name: "uploadSyetemService" });
    },
    // 获取list
    async getList() {
      await request({
        // url: `http://192.168.2.62:20001/portalCenter/rest/portalapp/findListByQue`,
        url: `https://portal-center-i.hnust.edu.cn/portalCenter/rest/portalapp/findListByQue`,
        method: "post",
        headerType: "portal",
        data: { enable: null },
      }).then((res) => {
        if (res.code !== 0) {
          this.$message.error("获取系统服务错误");
          return;
        }
        this.systemServiceList = res.data;
      });
    },
    // 编辑
    handleEdit(index, row) {
      console.log(index, row);
      this.$router.push({ name: "uploadSyetemService", query: { id: row.id } });
    },
    // 删除
    async handleDelete(index, row) {
      console.log(index, row);
      await request({
        url: `https://portal-center-i.hnust.edu.cn/portalCenter/rest/portalapp/delete`,
        method: "get",
        headerType: "portal",
        params: {
          id: row.id,
        },
      }).then((res) => {
        if (res.code !== 0) {
          this.$message.error("删除错误");
        } else {
          this.$message.succcess("删除成功");
          this.getList();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.systemServiceList {
  padding: 20px;
  padding-left: 70px;
}
.addService {
  margin-bottom: 20px;
}
</style>
